// 是否强制所有请求访问本地 MOCK，每个请求也可以单独控制是否请求 MOCK
export const AJAX_LOCALLY_ENABLE = false
// 是否开启监控
export const MONITOR_ENABLE = true
// 路由默认配置，路由表并不从此注入
export const ROUTER_DEFAULT_CONFIG = {
  // 数据加载完毕后再切换试图，也就是 点击之后先没反应，然后数据加载完，再触发过渡效果
  // 等到 data 處理完 (transition.next() 或是 Promise resolve)，才會進行組件渲染
  waitForData: true,
  // 初次加载是否启用场景切换
  transitionOnLoad: true
}

// axios 默认配置
export const AXIOS_DEFAULT_CONFIG = {
  // 基础路径
  baseURL: './',
  // 请求超时时间
  timeout: 60000,
  // 定义允许的响应内容的最大尺寸
  maxContentLength: 2000
}

// vuex 默认配置
export const VUEX_DEFAULT_CONFIG = {
  strict: false
}

// API 默认配置
export const API_DEFAULT_CONFIG = {
  mockBaseURL: 'http://127.0.0.1:8081',
  mock: AJAX_LOCALLY_ENABLE,
  debug: true,
  sep: '/'
}

// CONST 默认配置
export const CONST_DEFAULT_CONFIG = {
  sep: '/'
}

// 还有一些方便开发的配置
export const DEBUG_VUE_DEVTOOLS = process.env.NODE_ENV === 'development' // vue devtools 开关
export const DEBUG_VUE_DEBUG = process.env.NODE_ENV === 'development' // vue debug 开关
export const DEBUG_VUE_TIP = process.env.NODE_ENV === 'development' // vue tip 开关

export const CONSOLE_REQUEST_ENABLE = false //process.env.NODE_ENV === 'development' // 开启请求参数打印
export const CONSOLE_RESPONSE_ENABLE = false // process.env.NODE_ENV === 'development' // 开启响应参数打印
export const CONSOLE_MONITOR_ENABLE = false //process.env.NODE_ENV === 'development' // 监控记录打印


// 业务相关的配置
// 客户端类型 订单来源统计 | 10506 h5终端 | 10504 安卓终端 | 10505 苹果终端 |

// 静态文件地址
// 默认当前域名最后一级替换为sfile
let staticHost = `${process.env.VUE_APP_addressStatic}`
if (staticHost === '') {
  staticHost = location.protocol + '//sfile' + location.host.substr(location.host.indexOf('.'))
}

API_DEFAULT_CONFIG.URL = {
  api: `${process.env.VUE_APP_addressIp}/${process.env.VUE_APP_uireqprefix}/yixServerObt`,
  parent: `${process.env.VUE_APP_addressIp}/${process.env.VUE_APP_uireqprefix}/parentAppurl`,
  mqc: `${process.env.VUE_APP_addressIp}/${process.env.VUE_APP_uireqprefix}/mqcServer`,
  nginx: `${staticHost}`,
  // nginx: `//sfile${host.substr(host.indexOf('.'))}`,
  uploadFileUrl: `${process.env.VUE_APP_addressIp}/${process.env.VUE_APP_uireqprefix}/parentSystemDfs/1.0.0/file/web/upload`,
  // nginx:'https://sfile.qhtxtrip.com' //http://sfile.lingduankeji.com
}

// 请求头配置
AXIOS_DEFAULT_CONFIG.headers = {
  'Content-Type': 'application/json;charset=utf-8',
  'Accept-Language': 'zh-CN,zh;q=0.8',
  'y-cli': '',
  'token': '',
  'loginUserNo': '',
  'corpId':''
}

// 关爱通关联企业ID
export const GAT_CONFIG = {
  gatCorpId: `${process.env['VUE_APP_GAT_CORP_ID']}`,
}

// 研学配置信息
export const YX_CONFIG = {
  yxCorpId: `${process.env['VUE_APP_YX_CORP_ID']}`,
  yxAesKey: `${process.env['VUE_APP_YX_AES_KEY']}`,
  yxBackUrl: `${process.env['VUE_APP_YX_BACK_URL']}`,
}

// 福卡配置信息
export const FUKA_CONFIG = {
  fukaTag: 'fkApp',
}

// 大江看看APP配置信息
export const DJKK_CONFIG = {
  djkkAesKey: `${process.env['VUE_APP_DJKK_AES_KEY']}`,
}

export const APP_FROM = {
  amap_123: 'amap_123',
  tusu_123: 'tusu_123',
}
